<template>
  <div id="workspace-wrapper" ref="workspaceWrapper">
    <div class="bg-ball-cyan"></div>
    <div class="bg-ball-blue"></div>
    <div class="workspace-general-card">
      <div class="workspace-header">
        <picture>
          <source srcset="../assets/img/logo-MEC.webp" type="image/webp" />
          <source srcset="../assets/img/logo-MEC.png" type="image/png" />
          <img
            src="../assets/img/logo-MEC.png"
            alt="Logo MEC"
            width="76"
            height="42"
          />
        </picture>

        <div class="workspace-account-wrapper">
          <b-dropdown
            class="workspace-notif-btn"
            no-caret
            right
            v-if="selectedSection == 'home'"
          >
            <template #button-content>
              <div
                v-if="notificaciones.length > 0"
                class="workspace-notif-btn-number-cont"
              ></div>
              <b-icon icon="bell"></b-icon>
            </template>

            <div class="workspace-notif-header txt-bold">
              Bandeja de notificaciones
            </div>
            <article class="workspace-notif-body">
              <div
                class="workspace-notif-card"
                v-for="(notif, index) in notificaciones"
                :key="index"
              >
                <div class="workspace-notif-icon">
                  {{ notif.remitente.charAt(0) }}
                </div>

                <div class="workspace-notif-text-container">
                  <p class="workspace-notif-text">
                    {{ JSON.parse(notif.mensage).text }}
                  </p>
                </div>

                <div class="workspace-notif-check-container">
                  <label
                    class="workspace-notif-check-lbl"
                    :for="`workspace-notif-check${index}`"
                  >
                    <input
                      :id="`workspace-notif-check${index}`"
                      class="workspace-notif-check-input"
                      type="checkbox"
                      @change="getCheckNotification($event, notif.id)"
                    />

                    <span class="workspace-notif-check-switch"></span>
                  </label>

                  <!-- <b-form-checkbox
                    v-model="notifChecked[index]"
                    name="check-button"
                    @change="getCheckNotification($event, notif.remitente)"
                    switch
                  >
                  </b-form-checkbox> -->
                </div>

                <div
                  class="workspace-notif-btn-container"
                  v-if="
                    JSON.parse(notif.mensage).action == 'plantilla_compartida'
                  "
                >
                  <button
                    class="workspace-notif-grad-btn"
                    type="button"
                    @click="
                      getChangePlantillaState(
                        JSON.parse(notif.mensage).id_Plantillas_compartidas,
                        1,
                        notif.id
                      )
                    "
                  >
                    <span class="txt-bold">Aceptar</span>
                  </button>
                  <button
                    class="workspace-notif-grad-btn"
                    type="button"
                    @click="
                      getChangePlantillaState(
                        JSON.parse(notif.mensage).id_Plantillas_compartidas,
                        2,
                        notif.id
                      )
                    "
                  >
                    <span class="txt-bold">Rechazar</span>
                  </button>
                </div>
              </div>
            </article>
          </b-dropdown>

          <b-dropdown
            class="workspace-account-btn"
            :text="nombreIniciales"
            no-caret
            right
            v-if="selectedSection !== 'account'"
          >
            <div class="workspace-account-header">
              {{ nombreCompleto }}
            </div>
            <div class="workspace-account-body">
              <button
                class="workspace-account-list-btn"
                type="button"
                @click="
                  handleSectionChange({
                    section: 'account',
                    lastSection: selectedSection,
                  })
                "
              >
                <b-icon
                  class="workspace-account-icon"
                  icon="person-circle"
                ></b-icon>
                Ajustes de cuenta
              </button>

              <button
                class="workspace-account-list-btn"
                type="button"
                @click="handleLogout"
              >
                <div class="lds-ring" v-if="closing">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <b-icon
                  class="workspace-account-icon"
                  icon="power"
                  v-if="!closing"
                ></b-icon>
                {{ closing ? "Cerrando... " : "Cerrar Sesión" }}
              </button>
            </div>
          </b-dropdown>
        </div>
      </div>

      <AccountSection
        v-if="selectedSection === 'account'"
        :userDataAccount="userData"
        :idFuncionario="idFuncionario"
        @sectionChange="handleSectionChange"
        @getDatosSesion="handleUpdateSesion"
      />

      <HomeSection
        v-if="selectedSection === 'home'"
        :id_funcionario="idFuncionario"
        :recargasSesion="recargasSesion"
        @sectionChange="handleSectionChange"
        @getEvaluate="handleGetEvaluate"
      />

      <CreationSection
        v-if="selectedSection === 'creation'"
        :id_funcionario="idFuncionario"
        :nombreUsuario="nombreUsuario"
        @sectionChange="handleSectionChange"
        @getEvaluate="handleGetEvaluate"
      />

      <EditionSection
        v-if="selectedSection === 'edition'"
        @sectionChange="handleSectionChange"
        :plantillaEditarProp="{ plantillaEditar }"
      />

      <EvaluationSection
        v-if="selectedSection === 'evaluation'"
        :id_funcionario="idFuncionario"
        @sectionChange="handleSectionChange"
        @scrollTo="handleScroll"
        :plantillaEvaluarProp="{ plantillaEvaluar }"
      />
    </div>
  </div>
</template>

<script>
import HomeSection from "../components/Sections/HomeSection.vue";
import CreationSection from "../components/Sections/CreationSection.vue";
import AccountSection from "../components/Sections/AccountSection.vue";
import EvaluationSection from "../components/Sections/EvaluationSection.vue";
import EditionSection from "../components/Sections/EditionSection.vue";
import MEC_Funcionarios_api from "@/modules/MEC_Funcionarios_api";
import MEC_Notificaciones_api from "@/modules/MEC_Notificaciones_api";
import MEC_Plantillas_compartidas_api from "@/modules/MEC_Plantillas_compartidas_api";
import StoreHandler from "@/modules/StoreHandler";

export default {
  data() {
    return {
      closing: false,
      selectedSection: "home",
      recargasSesion: 0,
      plantillaEvaluar: {},
      plantillaEditar: {},
      notifChecked: [],
      notificaciones: [
        {
          remitente: "Jean Paul",
          mensage: `{"text":"Tienes pendiente una invitacion de German Chopara crear la plantilla 'NO_BORRAR'","action":"plantilla_compartida","id_Plantillas_compartidas":20}`,
          accion: "aceptarPlantilla",
        },
        {
          remitente: "Laura",
          mensage: `{"text":"Tienes pendiente una invitacion de German Chopara crear la plantilla 'NO_BORRAR'","action":"plantilla_compartida","id_Plantillas_compartidas":20}`,
          accion: "aceptarPlantilla",
        },
        {
          remitente: "Jean Paul",
          mensage: `{"text":"Tienes pendiente una invitacion de German Chopara crear la plantilla 'NO_BORRAR'","action":"plantilla_compartida","id_Plantillas_compartidas":20}`,
          accion: "notificar",
        },
        {
          remitente: "Jean Paul",
          mensage: `{"text":"Tienes pendiente una invitacion de German Chopara crear la plantilla 'NO_BORRAR'","action":"plantilla_compartida","id_Plantillas_compartidas":20}`,
          accion: "aceptarPlantilla",
        },
      ],
    };
  },

  props: [
    "userData",
    "idFuncionario",
    "correoUsuario",
    "nombreUsuario",
    "nombreCompleto",
    "nombreIniciales",
  ],

  components: {
    HomeSection,
    CreationSection,
    AccountSection,
    EvaluationSection,
    EditionSection,
  },

  watch: {
    correoUsuario() {
      this.getNotificaciones(this.correoUsuario);
    },
  },

  mounted() {
    this.getNotificaciones(this.correoUsuario);
  },

  methods: {
    async handleLogout() {
      const apiFuncionarios = new MEC_Funcionarios_api();
      const storage = new StoreHandler();
      this.closing = true;

      apiFuncionarios
        .getCerrarSession()
        .then((result) => {
          if (result.result == "1") {
            storage.clear();
            this.closing = false;
            this.handlePageChange("landing");
          } else {
            this.closing = false;
            console.log("Ha ocurrido un error");
          }
        })
        .catch((err) => {
          this.closing = false;
          console.log(err);
        });
    },

    async getNotificaciones(destinatario) {
      const apiNotificaciones = new MEC_Notificaciones_api();

      await apiNotificaciones
        .notificaciones_usuario(destinatario)
        .then((result) => {
          if (result.data.result) {
            this.notificaciones = result.data.result;
          } else {
            this.notificaciones = [];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getCheckNotification(event, id) {
      const apiNotificaciones = new MEC_Notificaciones_api();

      if (event.target.checked) {
        await apiNotificaciones
          .update_estado(id, 1)
          .then((result) => {
            this.getNotificaciones(this.correoUsuario);
            console.log(result);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        await apiNotificaciones
          .update_estado(id, 0)
          .then((result) => {
            console.log(result);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    async getChangePlantillaState(
      id_Plantillas_compartidas,
      accion,
      idNotificacion
    ) {
      const apiPlantillasCompartidas = new MEC_Plantillas_compartidas_api();

      await apiPlantillasCompartidas
        .aceptarRechazarPlantilla(id_Plantillas_compartidas, accion)
        .then((result) => {
          console.log(result);
        })
        .catch((err) => {
          console.log(err);
        });

      await this.getCheckNotification(
        { target: { checked: true } },
        idNotificacion
      );

      this.recargasSesion++;
    },

    handleGetEvaluate(plantilla) {
      this.plantillaEvaluar = plantilla;

      this.handleSectionChange({ section: "evaluation", lastSection: "home" });
    },

    handleGetEdit(plantilla) {
      this.plantillaEditar = plantilla;
      console.log(plantilla);
    },

    handleSectionChange(section) {
      this.selectedSection = section.section;
    },

    handleScroll(obj) {
      // console.log(obj);

      this.$refs.workspaceWrapper.scroll({
        top: obj.top,
        left: 0,
        behavior: "smooth",
      });
    },

    handleUpdateSesion() {
      this.$emit("updateDatosSesion");
    },

    handlePageChange(page) {
      this.$emit("pageChange", { page, lastPage: "workspace" });
    },
  },
};
</script>

<style>
/* ---------------------------------------------- Contenedor general Workspace */
#workspace-wrapper {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  background-color: var(--bg-color);
  /* background-image: url("../assets/img/MEC-bg-image-1.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center; */
}

/* ---------------------------------------------- Contenedor interno Workspace */
.workspace-general-card {
  margin: 40px auto;
  width: 90%;
  max-width: 1248px;
  min-height: calc(100vh - 80px);
  padding: 30px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 5;
}

/* ---------------------------------------------- Fila Logo y cuenta  */

.workspace-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.workspace-account-wrapper {
  display: flex;
  gap: 1rem;
}

.workspace-notif-btn,
.workspace-account-btn {
  width: 50px;
  height: 50px;
  border-radius: 50% !important;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: var(--grad-color-2);
}

.workspace-notif-btn > button {
  position: relative;
}

.workspace-notif-btn-number-cont {
  position: absolute;
  top: -3px;
  right: -3px;
  background-color: red;
  width: 15px;
  height: 15px;
  border-radius: 99px;
}

.workspace-notif-btn > button,
.workspace-account-btn > button {
  width: 45px !important;
  height: 45px !important;
  border-radius: 50%;
  padding: 0;
  flex: 0 0 auto !important;
  background-color: var(--black);
  border: none;
  color: var(--white);
  transition: all 0.3s ease-in-out;
}

.workspace-notif-btn > button:hover,
.workspace-account-btn > button:hover {
  background-color: transparent;
  color: var(--black);
}

.workspace-notif-btn ul,
.workspace-account-btn ul {
  width: 100vw;
  max-width: 300px;
  margin-top: 1rem;
  border: double 1px transparent;
  background-image: linear-gradient(var(--white), var(--white)),
    var(--grad-color-2);
  background-origin: border-box;
  background-clip: padding-box, border-box;
}

.workspace-notif-btn ul {
  max-height: 80vh;
  overflow-y: auto;
}

@media screen and (max-width: 768px) {
  .workspace-notif-btn ul,
  .workspace-account-btn ul {
    width: 200px;
  }
}

.workspace-notif-header,
.workspace-account-header {
  padding: 10px;
  text-align: center;
}

.workspace-notif-body,
.workspace-account-body {
  padding: 10px 0;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.workspace-notif-body {
  gap: 1rem;
}

.workspace-notif-card {
  margin: 0 auto;
  width: 90%;
  border-radius: 15px;
  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.1);
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr) 40px;
}

.workspace-notif-icon {
  margin: 0.5rem;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  background-color: var(--accent-color);
  color: var(--white);
  border-radius: 999px;
}

.workspace-notif-text-container {
  padding: 0.5rem;
}

.workspace-notif-text {
  margin: 0;
}

.workspace-notif-check-container {
  width: 80%;
  display: flex;
  justify-content: center;
  padding: 1rem 0;
}

.workspace-notif-check-lbl {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 15px;
}

.workspace-notif-check-input {
  width: 0px;
  height: 0px;
  opacity: 0;
}

.workspace-notif-check-switch {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 99px;
}

.workspace-notif-check-switch::before {
  position: absolute;
  content: "";
  height: 75%;
  width: 40%;
  left: 5%;
  bottom: 12.5%;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 99px;
}

.workspace-notif-check-lbl
  input:checked
  + .workspace-notif-check-switch::before {
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}

.workspace-notif-check-lbl input:checked + .workspace-notif-check-switch {
  background-color: blue;
}

.workspace-notif-btn-container {
  padding: 0.5rem 0;
  grid-area: 2 / 1 / 3 / 4;
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.workspace-notif-grad-btn {
  border: none;
  background-image: var(--grad-color-2);
  border-radius: 15px;
  padding: 2px;
}

.workspace-notif-grad-btn span {
  background-color: var(--white);
  padding: 0.2rem 0.5rem;
  border-radius: 13px;
  font-size: 14px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: color 0.5s linear, background-color 0.3s ease-in-out;
}

.workspace-notif-grad-btn:hover span {
  background-color: transparent;
}

.workspace-account-list-btn {
  width: 100%;
  height: 42px;
  border: none;
  outline: none;
  background-color: transparent;
  transition: background 0.3s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.workspace-account-list-btn .lds-ring div {
  border: 4px solid var(--black);
  border-color: var(--black) transparent transparent transparent;
}

.workspace-account-list-btn:hover {
  background-color: rgba(0, 0, 0, 0.2);
}

.workspace-account-list-btn:first-child {
  border-top: 1px solid var(--black);
  border-bottom: 1px solid var(--black);
}

.workspace-account-list-btn:last-child {
  border-bottom: 1px solid var(--black);
}

.workspace-account-icon {
  width: 20px;
  height: 20px;
}
</style>
